import { render, staticRenderFns } from "./booklet-template-html-image.vue?vue&type=template&id=11bf2586"
import script from "./booklet-template-html-image.vue?vue&type=script&lang=ts"
export * from "./booklet-template-html-image.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports